import styled from 'styled-components';

export const WorkflowContentLayout = styled.div`
  /* Scrolling is owned by the ODSU workflow-overlay card
     (owc-card__content-wrapper), so we do NOT add overflow here. */
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;

  padding: 2px; // in order to show effects
`;

export const WorkflowContentInnerLayout = styled.div`
  width: 100%;
  max-width: var(--default-breakpoint-width);
  margin-inline: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const WorkflowContentBody = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
`;

export const WorkflowContentFooter = styled.div`
  flex-shrink: 0;
  padding-top: 16px;
  padding-bottom: 16px;

  owc-button {
    width: 100%;
  }
`;
